import { render } from "./DialogRefundCompleted.vue?vue&type=template&id=4c6b4690"
import script from "./DialogRefundCompleted.vue?vue&type=script&lang=js"
export * from "./DialogRefundCompleted.vue?vue&type=script&lang=js"
script.render = render

export default script